<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-container>
      <v-card class="mx-auto" height="300px">
        <v-subheader>{{ $t('DASHBOARD.HABITATION') }}</v-subheader>
        <v-list dense class="pt-0">

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMERS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.business_customers }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('APARTMENTS.ITEMS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.apartments }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('APARTMENTS.FREE_APARTMENTS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.free_apartments }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('INHABITANTS.ITEMS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.inhabitants }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('BUILDINGS.ITEMS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.buildings }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('BUILDING_COMPLEXES.ITEMS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.building_complexes }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: 'HabitationCard',

  props: {
    info: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
